export enum NotificationType {
  Verbose,
  Info,
  Warning,
  Error,
}
